import { useSound } from '../../components/sound/soundContext';

export default function useIsNoiseOn() {
  const { isNoiseOn, setIsNoiseOn } = useSound();
  return { isNoiseOn, setIsNoiseOn };
}